import React, { useState } from 'react'
import { useNotifications } from '../stores/notification.context/notification.context'
import { useAuthStore } from '../stores/auth.context/auth.context'

export const NotificationTest: React.FC = () => {
  const { addPushNotification, playNotificationSound } = useNotifications()
  const { user, selectedHub } = useAuthStore()
  const [showDebugInfo, setShowDebugInfo] = useState(false)

  const getAnotherHubForTest = () => {
    if (!user || !user.hubs || user.hubs.length <= 1) return null

    const otherHub = user.hubs.find((hub) => hub.uuid !== selectedHub?.uuid)
    return otherHub
  }

  const handleClickSameHub = async () => {
    await addPushNotification('Notificação do Hub Atual', {
      body: 'Esta notificação é do hub que você está gerenciando atualmente',
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      data: {
        url: '/pedidos/123456',
        orderId: '123456',
        hubUuid: selectedHub?.uuid,
      },
    })
  }

  const handleClickDifferentHub = async () => {
    const otherHub = getAnotherHubForTest()

    if (otherHub) {
      await addPushNotification(`Notificação do Hub ${otherHub.name}`, {
        body: 'Esta notificação é de outro hub. Deve mostrar um modal de confirmação.',
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        data: {
          url: '/pedidos/7890123',
          orderId: '7890123',
          hubUuid: otherHub.uuid,
        },
      })
    } else {
      await addPushNotification('Notificação Sem Hub Específico', {
        body: 'Não foi possível encontrar outro hub para testar',
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        data: {
          url: '/pedidos/7890123',
          orderId: '7890123',
        },
      })
    }
  }

  const handlePlaySound = async () => {
    try {
      console.log('Tentando tocar som de notificação')
      if (playNotificationSound && typeof playNotificationSound === 'function') {
        await playNotificationSound()
          .then(() => console.log('Som de notificação tocado com sucesso'))
          .catch((error) => console.error('Erro ao tocar som:', error))
      } else {
        console.warn('playNotificationSound não está disponível')
      }
    } catch (error) {
      console.error('Erro ao chamar função de som:', error)
    }
  }

  const toggleDebugInfo = () => {
    setShowDebugInfo((prev) => !prev)
  }

  const renderDebugInfo = () => {
    if (!showDebugInfo) return null

    return (
      <div className='mt-3 p-3 bg-gray-100 rounded-md text-xs font-mono text-gray-800 max-w-xs overflow-auto'>
        <h3 className='font-bold mb-1'>Hub Atual:</h3>
        <pre className='mb-2'>{JSON.stringify(selectedHub, null, 2)}</pre>

        <h3 className='font-bold mb-1'>Outros Hubs:</h3>
        <pre>
          {JSON.stringify(user?.hubs?.filter((h) => h.uuid !== selectedHub?.uuid) || [], null, 2)}
        </pre>
      </div>
    )
  }

  return (
    <div className='fixed bottom-5 right-5 z-50 flex flex-col gap-2'>
      <button
        onClick={handleClickSameHub}
        className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'>
        Testar Notificação (Mesmo Hub)
      </button>
      <button
        onClick={handleClickDifferentHub}
        className='px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600'>
        Testar Notificação (Outro Hub)
      </button>
      <button
        onClick={handlePlaySound}
        className='px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600'>
        Testar Som
      </button>
      <div className='flex items-center mt-1'>
        <div className='text-xs text-gray-700 p-2 bg-white rounded shadow flex-grow'>
          Hub atual: {selectedHub?.name || 'Nenhum'}
        </div>
        <button
          onClick={toggleDebugInfo}
          className='ml-2 px-2 py-1 bg-gray-200 text-gray-700 rounded text-xs'>
          {showDebugInfo ? 'Ocultar' : 'Detalhes'}
        </button>
      </div>
      {renderDebugInfo()}
    </div>
  )
}
